import { filter } from 'rxjs/operators';
import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { AppState, MediaStreamElement } from '../../store/media.state';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
    selector: 'app-local-screen-videotag',
    templateUrl: './local-screen-video-tag.component.html',
    styleUrls: ['./local-screen-video-tag.component.scss']
})
export class LocalScreenVideoTagComponent implements OnInit, OnDestroy {

    @Input() fullsized: boolean;
    localScreenStreamElement$: Observable<MediaStreamElement>;
    private localStreamSubscription: Subscription = null;

    constructor(private elRef: ElementRef, private store: Store<AppState>) {
        this.localScreenStreamElement$ = this.store.select((state: AppState) => state.media.localScreenStream).pipe(filter(e => !!e));
    }

    ngOnInit(): void {
        this.localStreamSubscription = this.localScreenStreamElement$.subscribe(mediaElement => {
            if (mediaElement.active) {
                const video = this.elRef.nativeElement.querySelector('#local-screen-video-tag');
                video.srcObject = mediaElement.media.stream;
                video.muted = true;
            }
            if (!mediaElement.active) {
                const video = this.elRef.nativeElement.querySelector('#local-screen-video-tag');
                video.srcObject = null;
            }
        });
    }

    ngOnDestroy(): void {
        if (this.localStreamSubscription !== null) {
            this.localStreamSubscription.unsubscribe();
        }
    }
}
